
<template>
	<el-row class="wrap-left">
		<el-col style="text-align: center;padding: 30px 0;  ">
			<div style="cursor: pointer;" >
<!--				<el-upload-->
<!--						   :action="uploadFileUrl"-->
<!--						   :show-file-list="false"-->
<!--						   :on-success	="imageHandleAvatarSuccessUs"-->

<!--				@dblclick="triggerUpload"-->

				<!--				>-->
<!--					<el-tooltip content="双击切换头像！" placement="right" effect="light">-->
<!--						<img :src="userInfo.headImg"  :alt="'User Avatar'" class="headImgStyle" :style="headImgStyle" @error="userInfo.headImg = require('@/assets/img/defHeadImg.png')" width="70" height="70" />-->
<!--					</el-tooltip>-->
<!--				</el-upload>-->
				<el-upload
						ref="upload"
						:action="uploadFileUrl"
						:show-file-list="false"
						:on-success="imageHandleAvatarSuccessUs"
				>
					<el-tooltip content="点击切换头像！" placement="right" effect="light">
						<!-- 将双击事件绑定到 img 元素 -->
						<img :src="userInfo.headImg" :alt="'User Avatar'" class="headImgStyle" :style="headImgStyle"
							 @error="userInfo.headImg = require('@/assets/img/defHeadImg.png')"
							 width="70" height="70" />
					</el-tooltip>
				</el-upload>

			</div>
			<div style="cursor: pointer;" >
				<div  v-if="isNavMenuOpen" style="    font-size: 14px;color: #ccc;margin-top: 5px;">
					<span>{{userInfo.name}}</span><br>
					<span style="font-size: 10px;">{{userInfo.role}}</span>
				</div>
				<div v-else style="    font-size: 14px;color: #ccc;margin-top: 5px;">
					{{userInfo.name}}
				</div>
			</div>

		</el-col>
		<!--    <el-col class="v3-tabs"> <TopNav /> </el-col>-->
		<el-col :span="24" class="sidebar" :style="isNavMenuOpen ? 'width: 200px;' : ''">
			<el-menu
					class="el-menu-vertical-demo"
					router
					unique-opened
					@open="handleOpen"
					@close="handleClose"
					background-color="transparent"
					text-color="#8D9AB4"
					:default-active="defaultActiveMenu"
					ref="mySidemenu"
					:collapse="!isNavMenuOpen"
					active-text-color="#fff"
					:default-openeds="defaultOpeneds"
					@select="handleSelect"
			>
				<el-submenu
						v-for="item in menus"
						:index="item.name"
						:key="item.name"

						:class="isNavMenuOpen ? 'submenu-open' : ''"
				>
					<template slot="title">
						<i :class="item.meta.icon"></i>
						<span>{{ item.meta.title }}</span>
					</template>
					<el-menu-item-group>
						<el-menu-item
								v-for="sub in item.sub"
								:index="sub.name"
								:key="sub.name"
								v-text="sub.meta.title"
						></el-menu-item>
					</el-menu-item-group>
				</el-submenu>
			</el-menu>
		</el-col>
		<el-col style="text-align: center;position: absolute;bottom: 0;pointer-events: none;" >
			<img
					style="margin: 47px 0 1px 0;width: 228px;height: 280px;"
					referrerpolicy="no-referrer"
					src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngbb0d82112964c39cde17894520152d79e7c6ed5d00cdb2d1e4e366ce82ec4d83"
			/>
		</el-col>

	</el-row>
</template>

<script>
	import { mapGetters, mapState } from 'vuex'
	import TopNav from './top-nav'
	import {axios} from '../config/axios'
	let oneMenuMap = new Map();
	export default {
		components: {
			TopNav
		},
		data () {
			return {
				menus: [],
				userInfo:JSON.parse(localStorage.getItem("logistics-userInfo")),
				uploadFileUrl:this.baseURL+'user/upload',
				defaultActiveMenu: '', // 你可以设置默认激活的子菜单项的 index
				defaultOpeneds: [], // 这里设置默认展开的菜单项
			}
		},
		created: function () {
			this.getMenu();
			if (this.userInfo.headImg != null && this.userInfo.headImg != '' ){
				this.userInfo.headImg =  this.userInfo.headImg;
			}
			// 默认打开的菜单
			// if (this.$route.path !== this.defaultActiveMenu) {
			// 	this.$router.push(this.defaultActiveMenu);
			// }

		},
		computed: {
			...mapGetters(['activeTag','getCurrentTab','getNavMenuOpenIndex']),
			...mapState(['isNavMenuOpen']),
			headImgStyle() {
				// 当导航菜单未展开时，设置特定的样式
				return this.isNavMenuOpen ? '' : 'width: 40px;height:40px;';
			},
		},
		watch: {
			activeTag: function (newValue, oldValue) {
				this.$nextTick(() => {
					this.$refs.mySidemenu.activeIndex = this.activeTag
				})
			},
			getCurrentTab: function (newValue, oldValue) {
				//点击页面传过来的url，
				this.$nextTick(() => {
					this.setCurrentActive(newValue); // 确保在 DOM 更新完成后执行
				});
			},
			// 点击待办 展示相应的页面
			getNavMenuOpenIndex: function (newValue, oldValue) {
				let currentValue = newValue.substring(0,newValue.indexOf("_"));
				if ("物流管理" == currentValue){
					this.defaultOpeneds = [currentValue]
					this.defaultActiveMenu = '/Home/main/logistics-stat/order-review-stat';
				} else if ("财务管理-初审" == currentValue) {
					let dealStr = currentValue.substring(0,currentValue.indexOf("-"));
					this.defaultOpeneds = [dealStr]
					this.defaultActiveMenu = '/Home/main/finance-stat/order-payment-review';
				} else if ("财务管理-付款管理" == currentValue) {
					let dealStr = currentValue.substring(0,currentValue.indexOf("-"));
					this.defaultOpeneds = [dealStr]
					this.defaultActiveMenu = '/Home/main/finance-stat/order-payment-tow-review';
				}
				// 默认打开的菜单
				if (this.$route.path !== this.defaultActiveMenu) {
					this.$router.push(this.defaultActiveMenu);
				}
			}
		},
		methods: {
			homePage(){
				this.$router.push({
					name: 'home-page',  // 跳转首页
				})
			},
			imageHandleAvatarSuccessUs(res, file) {
				if (res.code == 200){
					this.userInfo.headImg  = res.data;
					console.info("=======res.data:",res.data);
					localStorage.setItem("logistics-userInfo",JSON.stringify(this.userInfo));
					this.editHeadImg();
				} else {
					this.Message.error("上传失败")
				}
			},
			triggerUpload() {
				// 通过 ref 调用 Element UI upload 的点击方法
				this.$refs.upload.$refs.input.click();
			},
			customHttpRequest(upload) {
				// 自定义上传行为，例如使用 axios
				const formData = new FormData();
				formData.append('file', upload.file);

				axios.post(upload.action, formData).then(response => {
					upload.onSuccess(response.data);
				}).catch(error => {
					upload.onError(error);
				});
			},
			editHeadImg(){
				axios.put('user/editHeadImg', {headImg:this.userInfo.headImg }).then(result => {
					if (result.code !== 200){
						console.log(result);
						return;
					}
				}).catch(err => {
					console.log(err);
				});
			},
			handleOpen (key, keyPath) {
				// console.log(key, keyPath)
				// console.log('Menu opened:', key);
			},
			handleClose (key, keyPath) {
				// console.log(key, keyPath)
			},
			handleSelect(key, keyPath) {
				// console.log('Menu handleSelect:', key);
				//
				// console.log(key, keyPath);
			},
			getMenu(){
				if (this.menus.length === 0){
					axios.get('/permission',{params:{type:0}}).then(result => {
						if (result.code !== 200){
							console.log(result);
						}
						let menuData = result.data;
						menuData.forEach(item =>{
							let oneMenu = {};
							let meta = {};
							if (item.parentId === 0){
								meta["icon"]=item.menuIcon;
								meta["title"]=item.permission;
								oneMenu["meta"] = meta;
								oneMenu["name"]=item.permission;
								oneMenu["sub"] = [];
								oneMenuMap.set(item.id,this.menus.length);
								this.menus.push(oneMenu);
							}else {
								const index = oneMenuMap.get(item.parentId);
								let sub = this.menus[index].sub;
								meta['icon'] = item.menuIcon;
								meta['index'] = item.url;
								meta['type'] = 'menu';
								meta['active'] = false;
								meta["title"]=item.permission;
								oneMenu['meta'] = meta;
								oneMenu['name'] =item.url;
								sub.push(oneMenu);
							}
						})
						localStorage.setItem("logistics-menu",this.menus);
					}).catch(err => {
						console.log(err);
					});
				}
			},
			// ========================================================================= 打开相应的节点========
			setCurrentActive(tabName) {
				for (let menu of this.menus) {
					for (let sub of menu.sub) {
						if (sub.meta.title ==tabName) {
							this.defaultOpeneds = [menu.name]
							this.defaultActiveMenu = sub.meta.index;
							this.$router.push(this.defaultActiveMenu);

						}
					}
				}
				return null; // 如果没有找到匹配的项
			},
		}
	}
</script>
<style lang="less" scoped>
	.sidebar {
		transition: width 0.3s ease;
	}

	.el-menu-vertical-demo {
		border: none;
		height: 100%;
		background-color: #f6f6f6;
		box-shadow: 2px 0 6px rgba(0,0,0,0.1);
	}

	.submenu-open {
		background-color: #fff;
		color: #333;
	}

	.el-menu-item-group {
		border-top: 1px solid #ececec;
	}

	.el-menu-item {
		color: #333;
	}

	.el-menu-item:not(.is-active):hover {
		background-color: #000;
	}

	.el-menu-item.is-active {
		background-color: #e7eaf1 !important;
		color: #409EFF !important;
	}

	.headImgStyle{
		border-radius: 50%;
	}
	.upload-component .el-upload {
		display: block;
		opacity: 0;
		width: 0;
		height: 0;
		overflow: hidden;
		position: absolute;
		z-index: -1;
	}
</style>
